import {openUserSaveConflictModal} from '@Modals/user-save-conflict-modal/user-save-conflict-modal';
import {EditorType} from '@Utils/misc.util';
import type {ConcurrentEditPayload} from './form-maker-storage-library';

export interface ConflictModalArgs {
  payload: ConcurrentEditPayload;
  /** Re-runs the save with SaveActionType.FORCE to overwrite the teammate's version. */
  onAcceptYours: () => void;
}

export function openFormMakerConflictModal(args: ConflictModalArgs): void {
  openUserSaveConflictModal({
    currentUserPictureURL: args.payload.currentUserPictureURL,
    otherUserPictureURL: args.payload.otherUserPictureURL,
    otherUserName: args.payload.otherUserName,
    editorType: EditorType.FORM,
    onAcceptYours: args.onAcceptYours,
    onAcceptTheirs: (): void => {
      window.location.reload();
    },
  });
}
